import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=9e9713f8&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"
import style0 from "./NotesView.vue?vue&type=style&index=0&id=9e9713f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e9713f8",
  null
  
)

export default component.exports